const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectorswish = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '[data-wishlist-card]',
  empty: '[data-wishlist-empty]',
  error: '[data-wishlist-error]',
  retry: '[data-wishlist-retry]',
  pageCount: '[data-wishlist-page-count]',
};

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.related-products')) initButtons();
  initGrid();
  updateWishlistCount();

  document.querySelector(selectorswish.retry)?.addEventListener('click', initGrid);
});

document.addEventListener('shopify-wishlist:updated', () => {
  initGrid();
  initButtons();
});

const fetchProductCardHTML = async (handle) => {
  const response = await fetch(`/products/${encodeURIComponent(handle)}?view=wish`);
  if (!response.ok) throw new Error(`Request failed for ${handle}`);

  const html = await response.text();
  const documentFromResponse = new DOMParser().parseFromString(html, 'text/html');
  const productCard = documentFromResponse.querySelector(selectorswish.productCard);
  if (!productCard) throw new Error(`Product card missing for ${handle}`);
  return productCard.outerHTML;
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const empty = document.querySelector(selectorswish.empty);
  const error = document.querySelector(selectorswish.error);

  grid.hidden = wishlist.length === 0;
  grid.setAttribute('aria-busy', wishlist.length ? 'true' : 'false');
  empty?.toggleAttribute('hidden', wishlist.length !== 0);
  error?.setAttribute('hidden', '');
  updateWishlistPageCount(wishlist.length);

  if (!wishlist.length) {
    grid.innerHTML = '';
    grid.classList.add(GRID_LOADED_CLASS);
    return;
  }

  try {
    const responses = await Promise.allSettled(wishlist.map(fetchProductCardHTML));
    const productCards = responses
      .filter((result) => result.status === 'fulfilled')
      .map((result) => result.value);

    if (!productCards.length) throw new Error('No wishlist products could be loaded');

    grid.innerHTML = productCards.join('');
    grid.hidden = false;
    grid.setAttribute('aria-busy', 'false');
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons(grid);

    document.dispatchEvent(new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist },
    }));
  } catch (loadError) {
    console.error('[Shopify Wishlist] Failed to load wishlist', loadError);
    grid.hidden = true;
    grid.setAttribute('aria-busy', 'false');
    error?.removeAttribute('hidden');
  }
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle;
    if (!productHandle) return;

    const isActive = wishlistContains(productHandle);
    button.classList.toggle(BUTTON_ACTIVE_CLASS, isActive);
    button.setAttribute('aria-pressed', String(isActive));

    if (button.dataset.wishlistBound === 'true') return;
    button.dataset.wishlistBound = 'true';
    button.addEventListener('click', () => updateWishlist(productHandle));
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectorswish.grid);
  if (grid) setupGrid(grid);
};

const initButtons = (scope = document) => {
  const buttons = scope.querySelectorAll(selectorswish.button);
  if (!buttons.length) return;

  setupButtons(buttons);
  document.dispatchEvent(new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() },
  }));
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist ? wishlist.split(LOCAL_STORAGE_DELIMITER).filter(Boolean) : [];
};

const setWishlist = (array) => {
  const uniqueWishlist = [...new Set(array.filter(Boolean))];
  if (uniqueWishlist.length) {
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, uniqueWishlist.join(LOCAL_STORAGE_DELIMITER));
  } else {
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  }

  document.dispatchEvent(new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: uniqueWishlist },
  }));
  updateWishlistCount();
  return uniqueWishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const index = wishlist.indexOf(handle);
  if (index === -1) wishlist.push(handle);
  else wishlist.splice(index, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => getWishlist().includes(handle);

const resetWishlist = () => setWishlist([]);

const updateWishlistPageCount = (count) => {
  const label = `${count} ${count === 1 ? 'producto' : 'productos'}`;
  document.querySelectorAll(selectorswish.pageCount).forEach((element) => {
    element.textContent = label;
  });
};

const updateWishlistCount = () => {
  const wishlist = getWishlist();
  document.querySelectorAll('[data-js-wishlist-count]').forEach((element) => {
    element.dataset.jsWishlistCount = String(wishlist.length);
    element.textContent = String(wishlist.length);
  });
  updateWishlistPageCount(wishlist.length);
};
